import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import ReportCard from "../../../../../components/reports/report-card.jsx";

const CardsContent = ({ data, boName }) => {

    useEffect(() => {
        const values = [
            ["Itens subtraídos", data?.stolen_item_qty  ?? 0],
            [`${boName} com Itens Subtraídos`, data?.with_stolen_items ?? 0],
            [`${boName} sem Itens Subtraídos`, data?.without_stolen_items ?? 0]
        ];

        ReportUtils.createExportableTable(["Descrição", "Quantidade"], values, 'Cards')
    }, [data]);

    return (
        <>
            <div className="flex flex-col">
                <div className="grid grid-cols-3">
                    <ReportCard title="Itens subtraídos" value={data?.stolen_item_qty ?? 0}/>
                    <ReportCard title={`${boName} com Itens Subtraídos`} value={data?.with_stolen_items ?? 0}/>
                    <ReportCard title={`${boName} sem Itens Subtraídos`} value={data?.without_stolen_items ?? 0}/>
                </div>
            </div>

            <div className="chart-divisor"/>
        </>
    );
};

export default CardsContent;